export default __webpack_public_path__ + "static/media/o7.26782ec0.jpg";